window.addEventListener('load', function () {
  var cc = initCookieConsent();
  cc.run({
    current_lang: 'cs',
    autoclear_cookies: true, // default: false
    theme_css:
      'https://cdn.jsdelivr.net/gh/orestbida/cookieconsent@v2.7.1/dist/cookieconsent.css',
    page_scripts: true, // default: false
    gui_options: {
      consent_modal: {
        layout: 'bar', // box/cloud/bar
        position: 'bottom center', // bottom/middle/top + left/right/center
        transition: 'slide', // zoom/slide
        swap_buttons: false, // enable to invert buttons
      },
      settings_modal: {
        layout: 'bar', // box/bar
        // position: 'left',           // left/right
        transition: 'slide', // zoom/slide
      },
    },
    languages: {
      cs: {
        consent_modal: {
          title: 'Používáme soubory cookies, bez nich to totiž nejde',
          description:
            'Tyto webové stránky používají soubory cookies a analytické nástroje s cílem vylepšení uživatelského prostředí, analýzy návštěvnosti webových stránek a zjištění zdroje návštěvnosti.<br>Svým souhlasem nám napomáháte zlepšovat naše služby. Kliknutím na tlačítko „Přijmout vše“, potvrzujete svůj souhlas k přístupu a zpracování výše uvedených souborů a analytik. <br><br>Své rozhodnutí můžete upravit kliknutím zde v <button type="button" data-cc="c-settings" class="cc-link">„Nastavení“</button> nebo změnit či odvolat stejným způsobem, ale nezapomeňte, že soubory cookies nám pomáhají zlepšovat chování stránek.',
          primary_btn: {
            text: 'Příjmout vše',
            role: 'accept_all', // 'accept_selected' or 'accept_all'
          },
          secondary_btn: {
            text: 'Odmítnout vše',
            role: 'accept_necessary', // 'settings' or 'accept_necessary'
          },
        },
        settings_modal: {
          title: 'Nastavení',
          save_settings_btn: 'Uložit nastavení',
          accept_all_btn: 'Příjmout vše',
          reject_all_btn: 'Odmítnout all',
          close_btn_label: 'Zavřít',
          cookie_table_headers: [
            { col1: 'Name' },
            { col2: 'Domain' },
            { col3: 'Expiration' },
            { col4: 'Description' },
          ],
          blocks: [
            {
              title: 'Jak používáme cookies 📢',
              description:
                'Cookies používáme k zajištění základních funkcí webu a také k zlepšení vašeho zážitku. Pro další podrobnosti o použivání cookies a dalších údajů si můžete přečíst na stránce <a href="https://www.eurobydleni.cz/pouzivani-cookies/text/12754" class="cc-link">Jak používáme cookies</a>.',
            },
            {
              title: 'Nezbytné cookies',
              description:
                'Tyto cookies jsou nezbytné pro správnou činnost webu. Bez těchto cookies nemůže stránkce fungovat správně',
              toggle: {
                value: 'necessary',
                enabled: true,
                readonly: true, // cookie categories with readonly=true are all treated as "necessary cookies"
              },
            },
            {
              title: 'Analytické cookies',
              description:
                'Slouží pro zapamatování si Vašich rozhodnutí v minulosti',
              toggle: {
                value: 'analytics', // your cookie category
                enabled: false,
                readonly: false,
              },
              cookie_table: [
                // list of all expected cookies
                {
                  col1: '^_ga', // match all cookies starting with "_ga"
                  col2: 'google.com',
                  col3: '2 years',
                  col4: 'description ...',
                  is_regex: true,
                },
                {
                  col1: '_gid',
                  col2: 'google.com',
                  col3: '1 day',
                  col4: 'description ...',
                },
              ],
            },
            {
              title: 'Reklamní cookies',
              description:
                'These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data is anonymized and cannot be used to identify you',
              description:
                'Cookies zaznamenavající použití informací jak interagujete se stránkou, jaké stránky jste navštívili a na co klikáte. Všechny data jsou anonymizované a nejde je zneužít pro Vaši identifikaci',
              toggle: {
                value: 'targeting',
                enabled: false,
                readonly: false,
              },
            },
            {
              title: 'Více informací',
              description:
                'Pokud máte dotazy ohleně cookies, nebo čehokoliv <a class="cc-link" href="https://www.eurobydleni.cz/kontakt/">kontaktujte náš přímo</a>.',
            },
          ],
        },
      },
    },
  });
});
